export type EventDocument = {
	fileName: string;
	fileId?: string; // undefined when the file is not downloadable
};

export type HistoryEventResult = {
	action: string | undefined; // result of transformAction
	actor: string; // "<firstName> <lastName>"
	timestamp: string | undefined; // formatted date string
	browserInfo: string; // "browserName, browserVersion, osName"
	document?: EventDocument; // file snapshotted at the event's moment (undefined if no file)
	priorDocument?: EventDocument; // version a replacement event superseded
	status: string;
	comment: string | null;
	kycFileId?: string | null;
	signingMethodLabel?: string | null;
	complianceLabel?: string | null;
};

export enum KycStepRightPanelTab {
	REVIEW = 'REVIEW',
	FILES = 'FILES',
	HISTORY = 'HISTORY',
}
